import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=d9cd6bfa&"
import script from "./Setting.vue?vue&type=script&async=true&defer=true&lang=js&"
export * from "./Setting.vue?vue&type=script&async=true&defer=true&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports